import DeliveryMethodsStepInfo from './DeliveryMethodsStepInfo';

export default DeliveryMethodsStepInfo;
